import useAccessToken from '@/pages/Auth/hooks/useAccessToken'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import DropdownListItemEdit from '@/shared/Dropdowns/DropdownListItem/DropdownListItemEdit'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'
import useDropdownUnderIconCtrl from '@/shared/Dropdowns/hooks/useDropdownUnderIconCtrl'
import { useState } from 'react'
import ExportIcon from '@/assets/icons/externalLink.svg?react'
import EditEquipmentPassportSidePage from '@/pages/Equipment/components/SidePages/EditEquipmentPassportSidePage'

interface IProps {
  equipment: IEquipment
}

const EquipmentPassportActionsMenu = (props: IProps) => {
  const threeDotsMenuCtrl = useDropdownUnderIconCtrl()
  const { passport } = useEquipmentPassport(props.equipment.passportInstanceId)
  const accessToken = useAccessToken()
  const [editSidePageOpen, setEditSidePageOpen] = useState(false)

  return (
    <>
      <DropdownUnderThreeDots
        open={threeDotsMenuCtrl.open}
        ref={threeDotsMenuCtrl.ref}
        setOpen={threeDotsMenuCtrl.setOpen}
        position="left"
      >
        <DropdownListItemEdit disabled={!passport} text={'Редактировать'} onClick={() => setEditSidePageOpen(true)} />
        <DropdownListItem
          icon={<ExportIcon />}
          onClick={() => equipmentUtils.openPDFPassport(props.equipment.id, accessToken)}
        >
          <span className="text-nm">Экспорт в PDF</span>
        </DropdownListItem>
      </DropdownUnderThreeDots>

      {passport && (
        <EditEquipmentPassportSidePage
          passport={passport}
          equipment={props.equipment}
          onCancel={() => setEditSidePageOpen(false)}
          open={editSidePageOpen}
        />
      )}
    </>
  )
}

export default EquipmentPassportActionsMenu
